<template>
  <section>
    <div class="left">
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
      <select-box v-if="showChannelSort"
                  id="channel-sort"
                  v-model="channelSortValue"
                  :options="channelsSortOptions"
      >
        <translate class="translate">Řazení</translate>
      </select-box>
    </div>
    <div class="right checkbox_group">
      <div class="field_left">
        <search-input v-model="search"></search-input>
      </div>
      <p class="check_all" v-if="showSelectAll && searchedItems.length > 0">
        <input
            :id="groupId + '-check-all'"
            name="groupId + '-check-all'"
            type="checkbox"
            v-model="toggleSelectAllVal"
            :disabled="disabled"
        >
        <label :for="groupId + '-check-all'" v-translate>Označit vše</label>
      </p>
      <div v-if="!singleList">
      <h2 class="checkbox_group_label" v-if="tvItems.length > 0" v-translate>TV kanály</h2>
      <ul class="settings">
        <list-checkbox-input
            v-for="item in tvItems"
            :key="item.id+redraw"
            :id="item.id"
            :name="item.name"
            :deleted="item.deleted"
            :selected-entities="prefixedSelectedIds"
            @input="select"
            :disabled="disabled"
        >
          <span v-if="prependChannelId" class="channel_id">{{ getItemIdText(item) }} </span>{{ item.name }}
          <channel-video-quality-label :quality="item.video_quality"></channel-video-quality-label>
          <channel-advertising-provider-channel-group-label
              :has-business-models="item.has_business_models"
              :business-models="item.business_models"
              @show-business-models="$emit('show-business-models', arguments[0])"
          />
          <span v-if="showNonlinear && hasCatchup(item.id)" :class="catchupClass(item.id)">{{catchupText(item.id) }}</span>
          <span v-if="showNonlinear && hasTimeshift(item.id)" :class="timeshiftClass(item.id)" :title="timeshiftTitle(item.id)"></span>
          <span v-if="showNonlinear && hasPvr(item.id)" :class="pvrClass(item.id)"></span>
          <span v-if="showNonlinear && hasPeriodicPvr(item.id)" :class="periodicPvrClass(item.id)"></span>
          <a v-if="showSettings && prefixedSelectedIds.includes(item.id)" @click.prevent.stop="onSettingsClick(item.id)" class="settings set" v-translate>Nastavení</a>
          <a v-if="showReplace && prefixedSelectedIds.includes(item.id)" @click.prevent.stop="onReplaceClick(item.id, 1)" class="settings change_channel set" v-translate>Vyměnit</a>
        </list-checkbox-input>
      </ul>
      <h2 class="checkbox_group_label" v-if="radioItems.length > 0" v-translate>Rádia</h2>
      <ul class="settings">
        <list-checkbox-input
            v-for="item in radioItems"
            :key="item.id+redraw"
            :id="item.id"
            :name="item.name"
            :deleted="item.deleted"
            :selected-entities="prefixedSelectedIds"
            @input="select"
            :disabled="disabled"
        >
          <span v-if="prependChannelId" class="channel_id">{{ getItemIdText(item) }} </span>{{ item.name }}
          <span v-if="showNonlinear && hasCatchup(item.id)" :class="catchupClass(item.id)">{{catchupText(item.id) }}</span>
          <span v-if="showNonlinear && hasTimeshift(item.id)" :class="timeshiftClass(item.id)" :title="timeshiftTitle(item.id)"></span>
          <span v-if="showNonlinear && hasPvr(item.id)" :class="pvrClass(item.id)"></span>
          <span v-if="showNonlinear && hasPeriodicPvr(item.id)" :class="periodicPvrClass(item.id)"></span>
          <a v-if="showSettings && prefixedSelectedIds.includes(item.id)" @click.prevent.stop="onSettingsClick(item.id)" class="settings set" v-translate>Nastavení</a>
          <a v-if="showReplace && prefixedSelectedIds.includes(item.id)" @click.prevent.stop="onReplaceClick(item.id, 2)" class="settings change_channel set" v-translate>Vyměnit</a>
        </list-checkbox-input>
      </ul>
      </div>
      <div v-else>
        <ul class="settings">
        <list-checkbox-input
            v-for="item in searchedItems"
            :key="item.id+redraw"
            :id="item.id"
            :name="item.name"
            :deleted="item.deleted"
            :selected-entities="prefixedSelectedIds"
            @input="select"
            :disabled="disabled"
        >
          <span v-if="prependChannelId" class="channel_id">{{ getItemIdText(item) }} </span>{{ item.name }}
          <span v-if="showNonlinear && hasCatchup(item.id)" :class="catchupClass(item.id)">{{catchupText(item.id) }}</span>
          <span v-if="showNonlinear && hasTimeshift(item.id)" :class="timeshiftClass(item.id)" :title="timeshiftTitle(item.id)"></span>
          <span v-if="showNonlinear && hasPvr(item.id)" :class="pvrClass(item.id)"></span>
          <span v-if="showNonlinear && hasPeriodicPvr(item.id)" :class="periodicPvrClass(item.id)"></span>
          <a v-if="showSettings && prefixedSelectedIds.includes(item.id)" @click.prevent.stop="onSettingsClick(item.id)" class="settings set" v-translate>Nastavení</a>
          <a v-if="showReplace && prefixedSelectedIds.includes(item.id)" @click.prevent.stop="onReplaceClick(item.id, 2)" class="settings change_channel set" v-translate>Vyměnit</a>
        </list-checkbox-input>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import {filterEntities, sortByKey} from "@/utils/helpers"
import channelsSortOptions from "../../components/mixins/channels-sort-options"
import ChannelVideoQualityLabel from "./ChannelVideoQualityLabel";
import ChannelAdvertisingProviderChannelGroupLabel from "./ChannelAdvertisingProviderChannelGroupLabel.vue";

export default {
  name: "ChannelCheckboxListSection",
  mixins: [channelsSortOptions],
  components: { ChannelAdvertisingProviderChannelGroupLabel, ChannelVideoQualityLabel},
  props: {
    groupId: String,
    title: String,
    description: String,
    items: Array,
    selectedItems: Array,
    buttonText: String,
    singleList: {
      type: Boolean,
      default: ()=> false,
    },
    searchKeys: {
      type: Array,
      default: () => ['name'],
    },
    prependChannelId: {
      type: Boolean,
      default: () => false,
    },
    showChannelSort: {
      type: Boolean,
      default: () => false,
    },
    editable: {
      type: Boolean,
      default: () => null,
    },
    showSelectAll: {
      type: Boolean,
      default: () => true,
    },
    showSettings: {
      type: Boolean,
      default: () => false,
    },
    showReplace: {
      type: Boolean,
      default: () => false,
    },
    showNonlinear: {
      type: Boolean,
      default: () => false,
    },
    nonlinearSettings: {
      type: Array,
      default: () => [],
    },
    nonlinearDataKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      search: '',
      redraw: 0,
      prefixedItems: this.mapItemsToPrefixed(this.items),
      prefixedSelectedIds: this.mapIdsToPrefixed(this.selectedItems),
      nonlinearSettingsInfo: {},
    }
  },
  created(){
    this.recalcNonlinearSettingsInfo();
  },
  computed: {
    disabled(){
      return this.editable !== null ? !this.editable :  !this.$_updateActionAllowed;
    },
    tvItems() {
      return this._.filter(this.searchedItems, (item) => {
        return Number(item.id_type) === 1
      })
    },
    radioItems() {
      return this._.filter(this.searchedItems, (item) => {
        return Number(item.id_type) === 2
      })
    },
    toggleSelectAllVal: {
      get() {
        for(const item of this.searchedItems){
          if(!this.prefixedSelectedIds.includes(item.id)){
            return false;
          }
        }
        return true;
      },
      set(value) {
        this.toggleSelectAll(value)
      }
    },
    searchedItems() {
      const sort = this.channelSortValue.split('-')
      const key = sort[0]
      const direction = sort[1]

      const filteredEntities = filterEntities([...this.prefixedItems], this.searchKeys, this.search)
      return sortByKey(filteredEntities, key, direction, key === 'name')
    },
  },
  methods: {
    getItemIdText(item){
      return item.id.slice(this.groupId.length);
    },
    mapIdsToPrefixed(ids){
      return ids.map((id) => this.mapIdToPrefixedId(id));
    },
    mapItemsToPrefixed(items){
      return items.map((item) => {
        item.id = this.mapIdToPrefixedId(item.id);
        return item;
      });
    },
    mapIdToPrefixedId(id){
      if(id.toString().startsWith(this.groupId)){
        return id;
      }else{
        return this.groupId + id;
      }
    },
    mapPrefixedIdsToIds(items){
      return items.map((item)=> item.toString().replace(this.groupId, ''));
    },
    mapPrefixedIdToId(id){
      return id.toString().replace(this.groupId, '');
    },
    toggleSelectAll(value) {
      let ids = [];
      let selected = [];
      this.searchedItems.forEach(function (item) {
        ids.push(item.id)
      });
      if(value){
        selected = [...new Set([...this.prefixedSelectedIds, ...ids])];
      }else{
       selected = this.prefixedSelectedIds.filter((item) => {
          return ids.indexOf(item) < 0;
        });
      }
      this.$emit('toggle-select', this.mapPrefixedIdsToIds(selected));
    },
    select(data) {
      let selected = this.prefixedSelectedIds;
      if(data.checked){
        selected.push(data.id);
      }else{
        let index = selected.indexOf(data.id);
        if(index > -1){
          selected.splice(index, 1);
        }
      }
      this.$emit('toggle-select', this.mapPrefixedIdsToIds(selected));
    },
    onSettingsClick(id){
      this.$emit('onSettingsClick', id);
    },
    onReplaceClick(id, channelType){
      this.$emit('onReplaceClick', id, channelType);
    },
    recalcNonlinearSettingsInfo(){
      this.nonlinearSettingsInfo = {};
      this.nonlinearSettings.forEach(item => {
        if(item.hasOwnProperty(this.nonlinearDataKey)) {
          item[this.nonlinearDataKey].forEach(id => {
            const prefixedId = this.mapIdToPrefixedId(id);
            this.nonlinearSettingsInfo[prefixedId] = {
              catchup: item.catchup,
              catchup_hours: item.catchup_hours,
              periodic_pvr: item.periodic_pvr,
              pvr: item.pvr,
              timeshift: item.timeshift
            }
          })
        }
      });

      this.redraw++;
    },
    hasCatchup(id) {
      return this.nonlinearSettingsInfo.hasOwnProperty(id) && this.nonlinearSettingsInfo[id].catchup != null;
    },
    hasTimeshift(id) {
      return this.nonlinearSettingsInfo.hasOwnProperty(id) && this.nonlinearSettingsInfo[id].timeshift != null;
    },
    hasPvr(id) {
      return this.nonlinearSettingsInfo.hasOwnProperty(id) && this.nonlinearSettingsInfo[id].pvr != null;
    },
    hasPeriodicPvr(id) {
      return this.nonlinearSettingsInfo.hasOwnProperty(id) && this.nonlinearSettingsInfo[id].periodic_pvr != null;
    },
    timeshiftClass(id) {
      if (this.nonlinearSettingsInfo[id].timeshift === true) {
        return 'timeshift_set'
      }
      if (this.nonlinearSettingsInfo[id].timeshift === false) {
        return 'timeshift_set timeshift_no'
      }
    },
    catchupClass(id) {
      if (this.nonlinearSettingsInfo[id].catchup === true) {
        return 'catchup_set'
      }
      if (this.nonlinearSettingsInfo[id].catchup === false) {
        return 'catchup_set catchup_no'
      }
    },
    catchupText(id){
      if (this.nonlinearSettingsInfo[id].catchup === true && this.nonlinearSettingsInfo[id].catchup_hours) {
        return this.nonlinearSettingsInfo[id].catchup_hours + "h";
      }
    },
    timeshiftTitle(id) {
      if (this.nonlinearSettingsInfo[id].timeshift === true) {
        return this.$gettext('Timeshift povolen')
      }
      if (this.nonlinearSettingsInfo[id].timeshift === false) {
        return this.$gettext('Timeshift zakázán')
      }
    },
    periodicPvrClass(id) {
      if (this.nonlinearSettingsInfo[id].periodic_pvr === true) {
        return 'periodic_rec_set'
      }
      if (this.nonlinearSettingsInfo[id].periodic_pvr === false) {
        return 'periodic_rec_set periodic_rec_no'
      }
    },
    pvrClass(id) {
      if (this.nonlinearSettingsInfo[id].pvr === true) {
        return 'pvr_set'
      }
      if (this.nonlinearSettingsInfo[id].pvr === false) {
        return 'pvr_set pvr_no'
      }
    },
  },
  watch: {
    items(values){
      this.prefixedItems = this.mapItemsToPrefixed(values);
    },
    selectedItems(values){
      this.prefixedSelectedIds = this.mapIdsToPrefixed(values);
    },
    nonlinearSettings(values){
     this.recalcNonlinearSettingsInfo();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ChannelCheckboxListSection.vue